<template>
  <div class="bg-gray">
  <div class="form-content">
    <div class="order-success">
      <div class="icon"></div>
      <div class="title">报名成功</div>
      <img :src="row.erweiimg[0].url" v-if="row.erweiimg.length>0" />
      <p v-if="row.erweiimg.length>0" >有关赛事信息将统一在赛事微信群公布，请各参赛队伍联系人或教练员主动加入并留意查看</p>
    </div>

    <el-form
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="单位" prop="name">{{row.danwei}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="队伍" prop="name">{{row.mingcheng}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="赛区" prop="name">{{row.saiqu_name}}</el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: center">
        <el-button round v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" v-if="row.need_video==1">{{row.video_ok ? '视频已上传' : '上传视频'}}
        </el-button>
      </div>

      <el-divider>秩序册信息</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="赛季" prop="name">{{pageData.sjname}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="赛区" prop="name">{{pageData.sqname}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位" prop="name">{{pageData.danwei}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="队伍名称" prop="name">{{pageData.mingcheng}}</el-form-item>
        </el-col>
        <el-col :span="12"  v-if="pageData.heying" >
          <el-form-item label="队伍照片" prop="name">
            <a :href="pageData.heying" target="_blank"><img style="max-height: 100px;" :src="pageData.heying" /></a>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider>人员信息</el-divider>
      <el-row :gutter="20">
        <el-col :span="12" v-for="(user ,index) in pageData.lingdui_list">
          <el-form-item label="领队">
            <el-tag
                :key="index"
                type="primary"
            > {{user.name}} {{user.num}}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-for="(user ,index) in pageData.jiaolianyuan_list">
          <el-form-item :label="'教练员'+(index+1)">
            <el-tag
                :key="index"
                type="primary"
            > {{user.name}} {{user.num}}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-for="(user ,index) in pageData.caipanyuan_list">
          <el-form-item :label="'裁判员'+(index+1)">
            <el-tag
                :key="index"
                type="primary"
            > {{user.name}} {{user.num}}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-for="(user ,index) in pageData.yundongyuan_list">
          <el-form-item :label="'运动员'+(index+1)">
                <el-tag
                    :key="index"
                    type="primary"
                > {{user.name}} {{user.num}}
                </el-tag>
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider>参赛人数</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="领队" prop="name">1</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="教练员" prop="name">{{pageData.jiaolianyuan_list.length}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="裁判员" prop="name">{{pageData.caipanyuan_list.length}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运动员" prop="name">{{pageData.yundongyuan_list.length}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总计" prop="name">{{pageData.member_total_count}}</el-form-item>
        </el-col>
      </el-row>

      <div v-for="(subject,index) in pageData.subject ">
        <el-divider>项目信息{{ index + 1 }}</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目" prop="name">{{subject.subject_name}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教练员" prop="jiaolian" v-for="(yundongyuan ,index) in subject.jiaolian">
              教练员{{index+1}}
              <el-tag
                  :key="index"
                  type="primary"
                  style="margin-right: 10px;"
              > {{ yundongyuan.name }} {{ yundongyuan.num}}
              </el-tag>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="参赛运动员" prop="type">
              <div v-for="(yundongyuan ,index) in subject.yundongyuan">
                运动员{{index+1}}
                <el-tag
                    :key="index"
                    type="primary"
                    style="margin-right: 10px;"
                > {{ yundongyuan.name }} {{ yundongyuan.num}}
                </el-tag>
              </div>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="替补运动员" prop="tbydy">
              <div v-for="(yundongyuan ,index) in subject.tbydy">
                替补运动员{{index+1}}
                <el-tag
                    :key="index"
                    type="primary"
                    style="margin-right: 10px;"
                > {{ yundongyuan.name }} {{ yundongyuan.num}}
                </el-tag>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="音乐试听" v-if="subject.sf_music_status==false&&subject.music_url&&subject.music_status==2"  prop="name">已试听</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="音乐试听" v-if="subject.sf_music_status==false&&subject.music_status==3"  prop="name">现场提交并核对</el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="现场照片服务" prop="name">{{subject.photo_service==1?'是':'否'}}</el-form-item>
          </el-col> -->
        </el-row>

      </div>
    </el-form>

    <el-row>
      <el-col class="footer-button">
        <el-button type="primary" v-rblink="{name:'SaiDateList'}">返回首页
        </el-button>
<!--        <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>-->
      </el-col>
    </el-row>

  </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.order-success{
  text-align: center;
  margin: 20px 0 ;
}
.order-success .icon{
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}
.order-success .title{
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.order-success img{
  width: 300px;
  height: 300px;
  margin: 10px auto;
}
.order-success p{
  font-size: 12px;
  color: #999;
}

.sai-shuo-li{
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px ;
  padding: 10px;
}
.sai-shuo-li img{
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}
.sai-shuo-li .c{
  width: calc(100% - 80px);
  border-right: 1px solid #00000008 ;
}
.sai-shuo-li .c .title{
  font-size: 14px;
  color: #000;
}
.sai-shuo-li .c .desc{
  font-size: 12px;
  color: #999;
}
.sai-shuo-li .fr{
  width: 70px;
  float: right;
}
.sai-shuo-li .btn{
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
  border-radius:6px;
  color: #fff;
}
.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
}

.memberResultWrap{
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}
.memberResultWrap .memberLi{
  font-size: 14px;
  color: #666;
  /* height: 36px; */
  line-height: 36px;
}
.memberResultWrap .memberLi .van-tag{
  width: auto !important;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading:false,
      showFamliyPicker:false,
      showSubjectPicker:false,
      showJiaolianPicker:false,
      showRoomTypePicker:false,
      showMemberPicker:false,
      formData:{
        id:0
      },
      row:{
        erweiimg:[]
      },
      pageData:{
        'jiankangpics' :[],
        'lingdui_list' :[],
        'yundongyuan_list' :[],
        'jiaolianyuan_list' :[],
        'caipanyuan_list' :[]
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '报名成功';
    if(that.formData.id){
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion(){
      console.log('onQuestion')
    },
    onMemberConfirm(values){
      console.log('onMemberConfirm',values)
      this.showMemberPicker = false;
      this.formData.member = [...values];
    },
    onMemberChange(values){
      console.log('onMemberChange',values)
      this.formData.member = [...values];
    },
    onRoomTypeConfirm(value, index){
      this.formData.roomTypeName = value;
      this.formData.roomtype = index+1;
      this.showRoomTypePicker = false;
    },
    fetch(){
      let that = this;
      that.$api.post('/api/isai/successdetail', {
        id:that.formData.id
      }, (res) => {
        that.row = res.data;
        that.pageData = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormSuccess.vue?193aff3e